import { useEffect } from "react";

// Injects (or updates) BarknFurs LocalBusiness JSON-LD on the homepage
// Helps Google show rich snippets (star rating, hours, location) in search results.
export default function LocalBusinessSchema() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "PetStore", // covers grooming + pet services
      name: "BarknFurs Grooming Studio",
      image: "https://barknfurs.com/favicon.png",
      "@id": "https://barknfurs.com",
      url: "https://barknfurs.com",
      telephone: "+91-8883339158",
      priceRange: "₹₹",
      address: {
        "@type": "PostalAddress",
        streetAddress: "VIM 142, VIM Colony, Sailashree Vihar",
        addressLocality: "Bhubaneswar",
        addressRegion: "Odisha",
        postalCode: "751021",
        addressCountry: "IN",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 20.3197,
        longitude: 85.8197,
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
          opens: "09:00",
          closes: "20:00",
        },
      ],
      sameAs: [
        "https://wa.me/918883339158",
      ],
      areaServed: {
        "@type": "City",
        name: "Bhubaneswar",
      },
      description:
        "BarknFurs is Bhubaneswar's premium pet grooming studio offering professional dog and cat grooming, bath, haircut, nail trim, spa and doorstep grooming services. Certified groomers, pet-safe products.",
      makesOffer: [
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Dog Grooming" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Cat Grooming" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Bath and Shampoo" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Hair Trim and Styling" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Spa Treatment" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Doorstep Grooming" } },
      ],
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.9",
        reviewCount: "500",
      },
    };

    let el = document.getElementById("local-business-jsonld");
    if (!el) {
      el = document.createElement("script");
      el.id = "local-business-jsonld";
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, []);

  return null;
}
